import List from "../pages/index/album/List";
import Photo from "../pages/index/album/Photo";
import Config from "../pages/index/album/Config";
import Statis from "../pages/index/album/Statis";

export default [
    {
        path: "",
        name: "Album.Default",
        redirect: {name: "Album.List"}
    },
    {
        name: "Album.List",
        path: "list",
        component: List,
        meta: {title: "相册列表"}
    },
    {
        name: "Album.Photo",
        path: ":id/photo",
        component: Photo,
        meta: {title: "图片列表"},
    },
    {
        name: "Album.Config",
        path: ":id/config",
        component: Config,
        meta: {title: "相册配置"},
        redirect: {name: "Album.Config.Default"},
        children: require("./album/config").default,
    },
    {
        name: "Album.Statis",
        path: ":id/statis",
        component: Statis,
        meta: {title: "数据统计"}
    }
];
